import moment from 'moment'

export const isToday = (time) => {
    const now = moment();
    const inputTime = moment(time);
    return now.isSame(inputTime, "day");
}

export const isValidPhoneNumber = (phoneNumber) => {
    // 正则表达式：匹配11位手机号码
    const regex = /^1[3-9]\d{9}$/;
    return regex.test(phoneNumber);
}

export const getChannel = (domain) => {
    const regex = /^([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/i;
    let c = 0;
    if (regex.test(domain)) {
        let hostname = domain.split('.');
        if (hostname.length > 2) {
            if (hostname.length > 3) {
                c = parseInt(hostname[hostname.length - 3])
            } else {
                c = parseInt(hostname[0])
            }
        }
        if (isNaN(c)) {
            c = 0
        }
    }
    return c;
}

export const countDown = (t) => {
    let targetTime = moment(t)
    let now = moment()

    let duration = moment.duration(targetTime.diff(now))

    let days = duration.days()
    let hours = duration.hours()
    let minutes = duration.minutes()
    let seconds = duration.seconds()

    let parts = []

    if (days > 0) parts.push(`${days}天`)
    if (days > 0 || hours > 0) parts.push(`${hours}时`)
    if (days > 0 || hours > 0 || minutes > 0) parts.push(`${minutes}分`)
    parts.push(`${seconds}秒`)

    return parts.join('')
}

export const updateUrlParams = (url, params = {}) => {
    if (url != "") {
        const urlObj = new URL(url);
        for (const [key, value] of Object.entries(params)) {
            urlObj.searchParams.set(key, value); // 添加或替换参数
        }
        return urlObj.toString();
    }
}

export const copy = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).catch((err) => {
            console.error('Clipboard API failed', err)
        })
    } else {
        // 兼容旧版：使用 document.execCommand 方式
        const textarea = document.createElement('textarea')
        textarea.value = text
        textarea.setAttribute('readonly', '')
        textarea.style.position = 'absolute'
        textarea.style.left = '-9999px'
        document.body.appendChild(textarea)
        textarea.select()
        try {
            document.execCommand('copy')
            console.log('Fallback: Copied')
        } catch (err) {
            console.error('Fallback: Copy failed', err)
        }
        document.body.removeChild(textarea)
    }
    return true
}
